@if (enableIntervalChange() && intervals) {
  <ng-container
    *ngTemplateOutlet="control; context: { options: intervals, value: interval, kind: 'interval' }"
  />
}

@if (enableCurrencyChange()) {
  <ng-container
    *ngTemplateOutlet="
      control;
      context: { options: currencies, value: currency(), kind: 'currency' }
    "
  />
}

<ng-template
  #control
  let-options="options"
  let-value="value"
  let-kind="kind"
  [ngTemplateType]="controlContextType"
>
  <rt-button
    #origin="rtOverlayOrigin"
    [dropdownOpened]="dropdown.open"
    (click)="dropdown.open = true"
    rt-overlay-origin
    variant="outline"
    margin-left-small
    >{{ label[kind] }}</rt-button
  >
  <ng-template
    #dropdown="rtConnectedOverlay"
    [open]="dropdown.open"
    [origin]="origin"
    (backdropClick)="dropdown.open = false"
    hasBackdrop
    rt-connected-overlay
  >
    <rt-dropdown>
      @for (option of options; track trackByOption($index)) {
        <rt-dropdown-item (click)="emitChange(kind, option.value); dropdown.open = false">
          {{ option.label }}
        </rt-dropdown-item>
      }
    </rt-dropdown>
  </ng-template>
</ng-template>
